import React from 'react';
import { Link } from 'react-router-dom';
import MetaTags from '../meta/MetaTags.jsx';
import './LandingSolutions.css';

const featureList = [
  { icon: '✉️', title: 'Digital Invites & RSVPs', body: 'Send polished evites instantly and track RSVPs, plus-ones, and responses without endless email threads.' },
  { icon: '🗺️', title: 'Collaborative Trip Planning', body: 'Build shared itineraries with travel details, schedules, and day-by-day updates everyone can follow.' },
  { icon: '✅', title: 'Task Management', body: 'Assign to-dos like booking venues or arranging transport so nothing slips through the cracks.' },
  { icon: '🗳️', title: 'Polls for Group Decisions', body: 'Let your group vote on dates, destinations, or activities for meetings, retreats, and weekend getaways.' },
  { icon: '💸', title: 'Budget Tracking', body: 'Track budgets and expenses in one place—whether you are splitting trip costs or managing a corporate event budget.' },
  { icon: '⭐', title: 'VIP Guest Modes', body: 'Invite VIPs with private access while keeping certain details hidden from general attendees.' },
];

export default function EventTripPlanning() {
  return (
    <>
      <MetaTags profileKey="eventPlanningTools" />
      <div className="landing-shell">
        <section className="section-hero">
          <span className="section-hero__eyebrow">Trip &amp; Event Planning</span>
          <h1 className="section-hero__title">All-in-One Trip and Event Planning Tools</h1>
          <p className="section-hero__subtitle">
            Plan events and group trips with digital invites, shared itineraries, polls, tasks, budgets, and VIP guest controls. Built for corporate event planning, meetings, and group travel.
          </p>
          <div className="cta-row" aria-label="Planner call to action">
            <Link to="/planner" className="btn primary">Open PartyDecider Planner</Link>
            <span className="cta-note">Free, modern, no downloads required.</span>
          </div>
        </section>

        <section className="section-grid section-grid--two">
          <div className="block-panel">
            <h2 className="block-panel__title">Plan with one platform</h2>
            <p className="block-panel__text">
              PartyDecider is an all-in-one digital event planner and trip planning platform that simplifies every step—from invites and RSVPs to itineraries, tasks, and budgets. Perfect for corporate conferences, offsites, family reunions, and casual meetups.
            </p>
            <ul className="block-list" aria-label="Event planning features">
              {featureList.map((item) => (
                <li key={item.title} className="block-list__item">
                  <span className="block-list__icon" aria-hidden="true">{item.icon}</span>
                  <div>
                    <p className="block-list__title">{item.title}</p>
                    <p className="block-list__body">{item.body}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <div className="block-panel">
            <h2 className="block-panel__title">Why use digital planning tools?</h2>
            <p className="block-panel__text">
              Instead of juggling spreadsheets, invite tools, and budget trackers, PartyDecider centralizes everything. Collaborate in real time, keep data in sync, and notify guests instantly when details change—no more scattered updates or missed messages.
            </p>
          </div>
        </section>

        <section className="section-columns">
          <div className="block-card">
            <div className="block-card__eyebrow">Group Trips</div>
            <h3 className="block-card__title">Plan group travel with ease</h3>
            <p className="block-card__text">
              Create a shared itinerary, add flights, hotels, and activities, and let the group vote on options. Assign tasks like “Book Airbnb” or “Reserve restaurant” so every detail is covered.
            </p>
          </div>
          <div className="block-card">
            <div className="block-card__eyebrow">Corporate &amp; Meetings</div>
            <h3 className="block-card__title">Meeting &amp; corporate event planning</h3>
            <p className="block-card__text">
              Propose times, let attendees vote, or confirm schedules that sync with calendars. Delegate tasks, monitor budgets, and use VIP access for clients or executives.
            </p>
          </div>
          <div className="block-card">
            <div className="block-card__eyebrow">Updates &amp; Invites</div>
            <h3 className="block-card__title">Integrated invitations and updates</h3>
            <p className="block-card__text">
              Design digital invitations and manage RSVPs in the same place you plan. Edit event details once and notify everyone instantly—no manual follow-ups required.
            </p>
          </div>
        </section>

        <section className="block-panel">
          <h2 className="block-panel__title">Ready to plan your next event or trip?</h2>
          <p className="block-panel__text">
            PartyDecider streamlines planning for weddings, corporate events, offsites, reunions, and casual get-togethers. Use polls, tasks, budgets, and digital invites to keep everyone aligned.
          </p>
          <div className="cta-row" aria-label="Planner call to action">
            <Link to="/planner" className="btn primary">Start in the Planner</Link>
            <Link to="/invitation-wedding-tools" className="btn outline">Explore invites &amp; weddings</Link>
          </div>
        </section>
      </div>
    </>
  );
}
